import type { PbxLocationsLocale } from './en'

export const pbxLocationsTeIn = {
  header: `స్థానాలు`,
  headerSubtext: `ఈ PBXలో కార్యాలయ స్థానాలను నిర్వహించండి. ప్రతి స్థానం ఒక E911 ఫోన్ నంబర్‌కు అనుసంధానించబడుతుంది, ఇది అత్యవసర కాల్‌లకు కాలర్ IDగా ఉపయోగించబడుతుంది.`,
  addLocation: `స్థానాన్ని జోడించండి`,
  searchPlaceholder: `స్థానాలను శోధించండి`,
  empty: `ఈ PBX కోసం ఇంకా ఎలాంటి స్థానాలు కాన్ఫిగర్ చేయబడలేదు.`,
  loadError: `స్థానాలను లోడ్ చేయడంలో విఫలమైంది.`,
  column: {
    name: `పేరు`,
    extensionCount: `ఎక్స్‌టెన్షన్‌లు`,
    e911Number: `E911 నంబర్`,
    e911Address: `E911 చిరునామా`,
    actions: `చర్యలు`,
  },
  notConfigured: `కాన్ఫిగర్ చేయబడలేదు`,
  notConfiguredE911Number: `E911 నంబర్ కేటాయించబడలేదు`,
  notConfiguredE911Address: `E911 చిరునామా నమోదు కాలేదు`,
  edit: `సవరించండి`,
  delete: `తొలగించండి`,
  extensionCountLabel_one: `{{count}} ఎక్స్‌టెన్షన్`,
  extensionCountLabel_other: `{{count}} ఎక్స్‌టెన్షన్‌లు`,
  form: {
    createHeader: `స్థానాన్ని జోడించండి`,
    editHeader: `స్థానాన్ని సవరించండి`,
    nameLabel: `పేరు`,
    namePlaceholder: `e.g. Main Office`,
    nameRequired: `పేరు తప్పనిసరి`,
    phoneNumberLabel: `E911 ఫోన్ నంబర్`,
    phoneNumberPlaceholder: `ఫోన్ నంబర్‌ను ఎంచుకోండి`,
    phoneNumberHelp: `ఈ స్థానం నుండి చేసే అత్యవసర కాల్‌లకు ఈ నంబర్ యొక్క E911 చిరునామా ఉపయోగించబడుతుంది.`,
    noAvailableNumbers: `కేటాయించడానికి ఫోన్ నంబర్‌లు అందుబాటులో లేవు.`,
    loadingAvailableNumbers: `అందుబాటులో ఉన్న నంబర్‌లను లోడ్ చేస్తోంది...`,
    cancel: `రద్దు చేయండి`,
    save: `సేవ్ చేయండి`,
    create: `స్థానాన్ని సృష్టించండి`,
    update: `స్థానాన్ని అప్‌డేట్ చేయండి`,
    createSuccess: `స్థానం సృష్టించబడింది.`,
    updateSuccess: `స్థానం అప్‌డేట్ చేయబడింది.`,
    createError: `స్థానాన్ని సృష్టించడంలో విఫలమైంది.`,
    updateError: `స్థానాన్ని అప్‌డేట్ చేయడంలో విఫలమైంది.`,
  },
  deleteModal: {
    header: `స్థానాన్ని తొలగించండి`,
    confirmMessage: `మీరు ఖచ్చితంగా "{{name}}"ను తొలగించాలనుకుంటున్నారా? దీన్ని రద్దు చేయడం సాధ్యం కాదు.`,
    reassignPrompt_one: `{{count}} ఎక్స్‌టెన్షన్ ఈ స్థానానికి కేటాయించబడింది; తొలగించే ముందు దాన్ని తిరిగి కేటాయించాలి. కొత్త స్థానాన్ని ఎంచుకోండి:`,
    reassignPrompt_other: `{{count}} ఎక్స్‌టెన్షన్‌లు ఈ స్థానానికి కేటాయించబడ్డాయి; తొలగించే ముందు వాటిని తిరిగి కేటాయించాలి. కొత్త స్థానాన్ని ఎంచుకోండి:`,
    reassignSelectPlaceholder: `గమ్యస్థాన స్థానాన్ని ఎంచుకోండి`,
    noOtherLocations: `ఈ PBXలో వేరే స్థానాలు లేవు. ముందుగా మరో స్థానాన్ని సృష్టించండి.`,
    cancel: `రద్దు చేయండి`,
    confirm: `తొలగించండి`,
    confirmReassign: `తిరిగి కేటాయించి తొలగించండి`,
    success: `స్థానం తొలగించబడింది.`,
    error: `స్థానాన్ని తొలగించడంలో విఫలమైంది.`,
  },
} satisfies PbxLocationsLocale
